export function formatNumber(
  num,
  digits = 3
) {
  const formatter = Intl.NumberFormat('en', {
    notation: 'compact',
    maximumSignificantDigits: digits,
  });

  return formatter.format(num);
}

export const sanitizeMaxDecimals = (value) => {
  if (value > -0.005 && value < 0.005) {
    return 0;
  } else {
    return value;
  }
};
